import React, { lazy, Suspense } from "react";

const PriceScreen = lazy(() => import("../components/PriceScreen"));

const renderLoader = () => <p>Loading</p>;

const LoginScreen = () => {
  return (
    <>
      <Suspense fallback={renderLoader()}>
        <PriceScreen />
      </Suspense>
    </>
  );
};

export default LoginScreen;
